import { render } from "./PackPlans.vue?vue&type=template&id=5d3781c1"
import script from "./PackPlans.vue?vue&type=script&lang=ts"
export * from "./PackPlans.vue?vue&type=script&lang=ts"
script.render = render

export default script